import React from "react";
import { Helmet } from "react-helmet";

/**
 * Componente de meta tags para SEO.
 * @param {string} title - Título da página (máx. ~60 caracteres)
 * @param {string} description - Meta description (máx. ~160 caracteres)
 * @param {string} keywords - Meta keywords
 * @param {string} canonical - URL canônica (opcional)
 * @param {string} ogImage - URL da imagem para Open Graph
 * @param {string} ogType - Tipo OG (website, article, etc.)
 */
export default function RenderHelmet({
  title,
  description,
  keywords,
  canonical,
  ogImage,
  ogType = "website",
}) {
  const url =
    typeof window !== "undefined"
      ? window.location.origin + window.location.pathname
      : "";

  const finalCanonical = canonical || url;
  const baseOrigin = typeof window !== "undefined" ? window.location.origin : "";
  const finalOgImage = ogImage || (baseOrigin ? `${baseOrigin}/logo-og.png` : "");

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && (
        <meta name="description" content={description}></meta>
      )}
      {keywords && <meta name="keywords" content={keywords}></meta>}
      <meta name="robots" content="index, follow"></meta>

      {/* Canonical - evita conteúdo duplicado */}
      {finalCanonical && (
        <link rel="canonical" href={finalCanonical} />
      )}

      {/* Open Graph - compartilhamento em redes sociais */}
      <meta property="og:title" content={title || ""} />
      <meta property="og:description" content={description || ""} />
      <meta property="og:url" content={finalCanonical} />
      <meta property="og:type" content={ogType} />
      {finalOgImage && (
        <meta property="og:image" content={finalOgImage} />
      )}
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:site_name" content="Cadê Direito" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || ""} />
      <meta name="twitter:description" content={description || ""} />
    </Helmet>
  );
}
